var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CollectionDetails',{attrs:{"hide-footer":"","hide-breadcrumbs":"","show-collection-products":_vm.collectionProducts,"show-collection-name":_vm.collectionName,"show-collection-photos":_vm.collectionPhotos,"is-shared-collection":true}})}
var staticRenderFns = []

export { render, staticRenderFns }